import React from "react";
import Pop from './Pop';
import './home.css';
import BottomBox from "./BottomBox";
import HomeBox from "./HomeBox";
import HomeLove from "./HomeLove";
import HomeRepl_A from "./HomeRepl_A";
import HomeRepl_B from "./HomeRepl_B";
import HomeRepr_A from "./HomeRepr_A";
import HomeSlider from "./HomeSlider";
import Helmet from 'react-helmet';
import ImageRow from './HomeRow';
import TestimonialSlider from './TestimonialSlider';
import SpecificationSection from "./SpecificationSection";

const Home = (prop) => {

    return (
        <>
            <Helmet>
                <meta name="viewport" content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no" />
            </Helmet>
            <Pop btcolor='black' />
            <HomeBox />
            <HomeLove head='Fully Automatic and Touchless Sanitizer'
                subhead="Here's why you'll love going Untouched:" />

            <HomeRepl_A imgaddress='/images/home_img/senitizer-1.png' subhead='Rechargeable Battery'
                subinfo='The rechargeable battery technology makes the entire device portable, eliminates socket issues, 
        and allows users to place the unit anywhere they choose. It saves time and money by using less energy for dispensing.'/>

            <HomeLove head='Robust Design & Smooth Functioning'
                subhead="Mechanical Structure, Electronic Boards & Software Code designed & developed,robustly.The inside pump can dispense the liquid as well as gel smoothly and it makes the product unique in the market." />

            <HomeRepr_A imgaddress='/images/home_img/senitizer-2.png' subhead='Innovative Mounting'
                subinfo='The mounting system consists of a mounting bracket with handling points that you can attach or place to any 
        sort of surface such as a cement concrete walls, glass surface, tiles & wooden surfaces, etc., making it convenient and
         simple to handle because you can hang this machine simply anywhere.'/>

            <HomeRepl_B imgaddress='/images/home_img/senitizer.191.png' subhead='Simple Refiling with Smart Inlet'
                subinfo="The smart cap's one-of-a-kind design allows you to save time and liquid waste while pouring,
         and it's simple to open and close."/>

            {/* <HomeRepr_B imgaddress='/images/storyPage_img.png' subhead='Sleek, sturdy design'
        subinfo="Inside pump makes users more happy as this device can dispense liquid & gel.
         The pump can give the viscosity from this to this."/> */}

            <HomeSlider />
            <h1 className="H1-title">This Machine We Have Designed For</h1>

            <ImageRow />
            <SpecificationSection/>
            <TestimonialSlider />

            {/* <div className="card__section__head">
          <h1>This Machine We Have Designed For</h1>
        </div> */}

            {/* ---------- card section------------------------ */}
            {/* <div className="card__section">
          
          <Card sx={theme => ({ [theme.breakpoints.between(0,600)]:{width: '100vw',height:'50vh'},           
                            [theme.breakpoints.up('md')]:{ width: '18vw',height:'40vh',marginRight:'2%'}
                            })}>
          <CardMedia
            component="img"
            alt="img"
            height="140"
            image="/static/images/cards/contemplative-reptile.jpg"/>
          <CardContent>
            <Typography className="home__card__head"  gutterBottom variant="h5" component="div">
            <div  className="home__card__head">Hospitals and clinics</div>  
            </Typography>
            <Typography className="home__card__subhead" variant="h4" color="text.secondary">
            <div className="home__card__subhead">They take care of our health while we take care of our hygiene</div> 
            </Typography>
          </CardContent>
        </Card>
          <Card sx={theme => ({ [theme.breakpoints.between(0,600)]:{width: '100vw',height:'50vh'},           
                            [theme.breakpoints.up('md')]:{ width: '18vw',height:'40vh',marginRight:'2%'}
                            })}>
          <CardMedia
            component="img"
            alt="img"
            height="140"
            image="/static/images/cards/contemplative-reptile.jpg"/>
          <CardContent>
            <Typography className="home__card__head"  gutterBottom variant="h5" component="div">
            <div  className="home__card__head">Hospitals and clinics</div>  
            </Typography>
            <Typography className="home__card__subhead" variant="h4" color="text.secondary">
            <div className="home__card__subhead">They take care of our health while we take care of our hygiene</div> 
            </Typography>
          </CardContent>
        </Card>
          <Card sx={theme => ({ [theme.breakpoints.between(0,600)]:{width: '100vw',height:'50vh'},           
                            [theme.breakpoints.up('md')]:{ width: '18vw',height:'40vh',marginRight:'2%'}
                            })}>
          <CardMedia
            component="img"
            alt="img"
            height="140"
            image="/static/images/cards/contemplative-reptile.jpg"/>
          <CardContent>
            <Typography   gutterBottom variant="h5" component="div">
              <div  className="home__card__head">Hospitals and clinics</div>  
            </Typography>
            <Typography  variant="h4" color="text.secondary">
             <div className="home__card__subhead">They take care of our health while we take care of our hygiene</div> 
            </Typography>
          </CardContent>
        </Card>
          <Card sx={theme => ({ [theme.breakpoints.between(0,600)]:{width: '100vw',height:'50vh'},           
                            [theme.breakpoints.up('md')]:{ width: '18vw',height:'40vh',marginRight:'2%'}
                            })}>
          <CardMedia
            component="img"
            alt="img"
            height="140"
            image="/static/images/cards/contemplative-reptile.jpg"/>
          <CardContent>
            <Typography className="home__card__head"  gutterBottom variant="h5" component="div">
            <div  className="home__card__head">Hospitals and clinics</div>  
            </Typography>
            <Typography className="home__card__subhead" variant="h4" color="text.secondary">
            <div className="home__card__subhead">They take care of our health while we take care of our hygiene</div> 
            </Typography>
          </CardContent>
        </Card>

        </div> */}

            {/* <HomeTechie/> */}

            {/* <div className="testimonial__sec">
          <h2>Testimonial</h2>
         <div className="sub__testi">
          <div>what People Say About Us</div>
          <div>
            <Card sx={{ marginRight:'2%',width: '18vw',height:'40vh' }}>
            <CardMedia
              component="img"
              alt="img"
              height="140"
              image="/static/images/cards/contemplative-reptile.jpg"/>
            <CardContent>
      
            </CardContent>
          </Card>
        </div>
         </div>
        </div> */}
            <BottomBox />

        </>
    );
}

export default Home;